import React, { Suspense } from "react";
import { Redirect, Route, Switch } from "react-router-dom";

const ShiftSession = React.lazy(
  () => import("../../../containers/pages/shift-session"),
);

const ShiftSessionPages = ({ match }) => (
  <div className="dashboard-wrapper">
    <Suspense fallback={<div className="loading" />}>
      <Switch>
        <Route path={`${match.url}/`} render={(props) => <ShiftSession {...props} />} />
        <Redirect to="/error" />
      </Switch>
    </Suspense>
  </div>
);

export default ShiftSessionPages;
